module.exports = __webpack_public_path__ + "assets/61d78ecd864e393a37741f5c47945b52.mp3";